import { put, call, take, fork } from 'redux-saga/effects'
import { CourseCreationSuggestPageTitleService } from '../../api/course-creation'
import { aICreatorSuggestPageTitleSuccess } from '../../reducers/ai-creator/action'
import { SUGGEST_PAGE_TITLE } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 * Flow for suggesting page titles
 * @param {Object} payload - The payload containing requestData and callback
 */
function* suggestPageTitleFlow(payload) {
  try {
    const { requestData, callback } = payload

    const response = yield call(
      CourseCreationSuggestPageTitleService,
      requestData,
    )

    yield put(aICreatorSuggestPageTitleSuccess(response))
    yield put(operationSuccess())

    if (callback) {
      callback(response)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 * Watcher for suggest page title actions
 */
export default function* aICreatorSuggestPageTitleWatcher() {
  while (true) {
    const action = yield take(SUGGEST_PAGE_TITLE)
    const { payload } = action

    yield fork(generalSaga, suggestPageTitleFlow, payload, false)
  }
}
